/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_1_DescInputs */

const en_mk_feature_1_desc = /** @type {(inputs: Mk_Feature_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One inbox for approvals, comments, and work needing help, with a clear next action.`)
};

const id_mk_feature_1_desc = /** @type {(inputs: Mk_Feature_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox menyatukan persetujuan, komentar, dan pekerjaan yang perlu bantuan, dengan tindakan berikutnya.`)
};

/**
* | output |
* | --- |
* | "One inbox for approvals, comments, and work needing help, with a clear next action." |
*
* @param {Mk_Feature_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_1_desc = /** @type {((inputs?: Mk_Feature_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_1_desc(inputs)
	return en_mk_feature_1_desc(inputs)
});